"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleGoBackSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleGoBackSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ componentName }) {
        super({ componentName });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_GO_BACK;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleGoBackSchema = ClickFreeModuleGoBackSchema;
